import { ITheme, mergeStyleSets } from "@fluentui/react";

export const getCellStyles = (theme: ITheme) => {
    return mergeStyleSets({
        notificationIconRoot: {
            cursor: 'pointer',
            marginLeft: 5
        },
        labelSuffixWrapper: {
            display: 'flex',
            alignItems: 'center'
        },
        notificationWrapper: {
            marginTop: 10,
            marginBottom: 10,
        },
        notificationContent: {
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 'initial !important',
            gap: 5
        },
        notificationMessageTitle: {
            color: theme.palette.themePrimary,
            fontWeight: 600,
        },
        notificationApplyButtonRoot: {
            minHeight: 24,
            paddingLeft: 8,
            paddingRight: 8,
            width: 'fit-content',
            minWidth: 60
        }
    });
};